import Vue from 'vue';
import { trackCubePageViewPds, trackProductView } from '../tracking/trackingLayer';
import { trackABTests } from '../tracking/trackingABTest';
import bilderAnsicht from '../bilder-ansicht/bilder-ansicht.vue.component';
import farben from '../farben/farben.vue.component';
import warenkorbbutton from '../warenkorbbutton/warenkorbbutton.vue.component';
import groessenLayer from '../groessen-layer/groessen-layer.vue.component';
import wishlistContainer from '../wishlist-container/wishlist-container.vue.component';
import stoerer from '../stoerer/stoerer-liste.vue.component';
import pangv from '../preisbereich/pangv.vue.component';

// Vue.config.devtools = true;
// Vue.config.errorHandler = (error, vm, info) => {
//   // err: error trace
//   // vm: component in which error occured
//   // info: Vue specific error information such as lifecycle hooks, events etc.
//   console.error(error, vm, info);
// };

// Ignore some Vue warnings:
Vue.config.warnHandler = (msg, instance, trace) => ![
  'Templates should only be responsible for mapping the state to the UI. Avoid placing tags with side-effects in your templates',
].some(warning => msg.includes(warning)) && console.warn('[Vue warn]: '.concat(msg) // NOSONAR
  .concat(trace));

let i18n = {};
try {
  i18n = JSON.parse(document.querySelector('#vue-data-i18n').textContent);
} catch (e) {
  // ignored
}
const outfit = () => import('../outfit/outfit.vue.component');
const cardpreisInfo = () => import('../preisbereich/cardpreis-info.vue.component');
const hvaLink = () => import('../hva-link/hva-link.vue.component');
const productDetailAccordion = () => import('../product-detail-accordion/product-detail-accordion.vue.component');
const bilderAnsichtThumbnails = () => import('../bilder-ansicht-thumbnails/bilder-ansicht-thumbnails.vue.component');
const partnerinfobox = () => import('../partnerinfobox/partnerinfobox.vue.component');
const vsp = () => import('../sticky-vsp-bar/sticky-vsp-bar.vue.component');

export default ({
  syan,
  article,
  initialKey,
  productJSON,
  productDetailsJSON,
  trackingStaticData,
}) => ({
  el: '#bewerten-vue-pds',

  data: {
    produktId: syan,
    // active article
    active: article[initialKey],
    activeImage: {},
    previewImage: null,
    previewPreis: null,
    previewColor: null,
    artikelNr: initialKey,
    initialNr: initialKey,
    verkaufId: article[initialKey].verkaufId,
    lastSelectedSize: null,
    artikelListe: article,
    i18n,
    trackingStaticData,
  },

  delimiters: ['$[', ']'],

  components: {
    outfit,
    'image-main-bildansicht': bilderAnsicht,
    'color-list': farben,
    'add-to-cart-button': warenkorbbutton,
    'cardpreis-info': cardpreisInfo,
    pangv,
    hvaLink,
    'product-detail-accordion': productDetailAccordion,
    'groessen-layer': groessenLayer,
    'bilder-ansicht-thumbnails': bilderAnsichtThumbnails,
    partnerinfobox,
    'wishlist-container': wishlistContainer,
    stoerer,
    'sticky-vsp-bar': vsp,
  },

  computed: {
    productDetails() {
      if (productDetailsJSON === '') {
        return {};
      }
      const blueprint = productDetailsJSON.blueprint;
      const artikelContent = productDetailsJSON[this.artikelNr];

      return {
        ...blueprint,
        ...artikelContent,
      };
    },
    isInitialArticle() {
      return this.$data.active.initial || false;
    },
    hasAliasArticle() {
      return this.$data.active.alias || false;
    },
    mandatoryDimension() {
      // FIXME: introduce flag in json data?
      let dimension = null;
      if (this.$data.active.groessen) {
        dimension = 'groessen';
      } else {
        dimension = 'farben';
      }
      return dimension;
    },
    displayPrice() {
      if (this.previewPreis) {
        return this.previewPreis;
      }
      return this.active.preis;
    },
    displayColor() {
      if (this.previewColor) {
        return `${i18n['ents.vue-data.color']}: ${this.previewColor.name}`;
      }
      if (this.active.preis) {
        return `${i18n['ents.vue-data.color']}: ${this.active.farben.aktiv.name}`;
      }
      return i18n['ents.vue-data.choose-color'];
    },
  },

  created() {
    this.$on('bewerten:vue:artikel:changed', (artikelNr) => {
      this.selectArtikelById(artikelNr || this.$data.artikelNr, false);
      this.triggerVariantenwechselEvents();
      this.$set(this.$data, 'lastSelectedSize', this.$data.active.groessen.aktiv.name);
    });

    this.$on('bewerten:vue:farbe:changed', (colorId) => {
      const jsonArtikel = productJSON.artikel[colorId];

      let artikelNr = colorId;

      // keep the selected size, when change colors
      if (this.jsonArtikelHasFarben(jsonArtikel) && this.jsonArtikelHasGroessen(jsonArtikel)) {
        jsonArtikel.groessen.werte.forEach((item) => {
          if (item.name === this.$data.lastSelectedSize && item.artikelNr !== undefined) {
            artikelNr = item.artikelNr;
          }
        });
      }

      this.selectArtikelById(artikelNr, false);
      this.triggerVariantenwechselEvents();
    });

    this.$on('bewerten:vue:farbe:preview', (artikelNr) => {
      if (artikelNr === undefined || artikelNr === null) {
        this.$set(this.$data, 'previewImage', null);
        this.$set(this.$data, 'previewPreis', undefined);
        this.$set(this.$data, 'previewColor', undefined);
      } else {
        const newImages = article[artikelNr].ansichten;
        this.$set(this.$data, 'previewImage', newImages[0]);
        this.$set(this.$data, 'previewPreis', article[artikelNr].preis);
        this.$set(this.$data, 'previewColor', article[artikelNr].farben.aktiv);
      }
    });

    this.$on('bewerten:vue:dimension:select', (selectParams) => {
      this.selectDimension(selectParams);
    });

    this.$on('bewerten:vue:layer:hide', () => {
      this.hideLayer();
    });

    this.$bus.$on('bewerten:out-of-stock-layer:show', (vertriebsinfoId) => {
      document.dispatchEvent(new CustomEvent('pruefen:best:wvb-overlay:open', {
        detail: {
          vertriebsinfoId,
          source: 'pds',
        },
      }));
    });

    this.$bus.$on('ents:vue:product-family:created', () => {
      this.updateProductFamilyUri();
    });

    trackABTests();
  },

  mounted() {
    Vue.nextTick(() => {
      // select single available article for dimensions with only one article
      if (this.isInitialArticle) {
        this.selectInitialArticle();
      }

      if (this.hasAliasArticle) {
        this.selectAliasArticle();
      }

      this.sendProductViewTracking();

      const body = document.getElementsByTagName('body')[0];
      body.className += ' bewerten-body--ready';
      document.dispatchEvent(new CustomEvent('bewe:ents:vue-ready'));
    });
    this.updateProductFamilyUri();
    window.performance.mark('bewe.pds.vue.mounted');
    window.performance.measure('bewe.pds.vue.ready', 'domInteractive', 'bewe.pds.vue.mounted');
    this.sendPageviewTracking();
    document.dispatchEvent(new CustomEvent('camp:aktionsflags:initialized'));
  },

  methods: {
    // keep 'this' pointing to vue instance, don't use fat arrow here
    selectArtikelById(artikelNr, init) {
      const oldImages = this.$data.active.ansichten;
      const newImages = article[artikelNr].ansichten;

      if (this.compareImageArrays(oldImages, newImages)) {
        // only update images if they differ between current and new article
        const images = this.$data.active.ansichten;
        this.setNewActiveArtikel(artikelNr);
        this.$set(this.$data.active, 'ansichten', images);
      } else {
        this.setNewActiveArtikel(artikelNr);
      }

      if (this.hasAliasArticle) {
        this.selectAliasArticle();
      } else {
        this.$set(this.$data, 'artikelNr', artikelNr);
        this.$set(this.$data, 'verkaufId', this.$data.active.verkaufId);
      }

      if (this.isInitialArticle) {
        this.selectInitialArticle();
      }

      this.rewriteURI(init);
      this.updateProductFamilyUri();
    },

    setNewActiveArtikel(artikelNr) {
      this.$set(this.$data, 'active', article[artikelNr]);
    },

    rewriteURI(init) {
      const location = window.location;
      const pathname = location.pathname;
      const queryString = location.search;

      if (window.history.replaceState) {
        let uri;
        if (init) {
          uri = pathname + queryString.replace(/(variant=)[^&]+/, `$1${this.$data.artikelNr}`);
        } else {
          uri = `${pathname}?variant=${this.$data.artikelNr}`;
        }
        window.history.replaceState(null, null, uri);
      }
    },

    updateProductFamilyUri() {
      this.$bus.$emit('ents:vue:product-family:update', this.$data.active.productFamilyUri);
    },

    selectInitialArticle() {
      if (this.$data.active[this.mandatoryDimension] && this.$data.active[this.mandatoryDimension].werte.length === 1) {
        this.selectArtikelById(this.$data.active[this.mandatoryDimension].werte[0].artikelNr, true);
      }
    },

    selectAliasArticle() {
      this.$set(this.$data, 'artikelNr', this.$data.active.alias);
      this.$set(this.$data, 'verkaufId', this.$data.active.verkaufId);
    },

    selectDimension(selectParams) {
      if (selectParams.dimension === 'groessen') {
        this.$bus.$emit('bewerten:vue:sizes:highlight:show', selectParams.add2CartAfterSizeSelection);
      } else {
        const $layer = document.querySelector('#ents-layer__farben');
        if ($layer != null) {
          $layer.classList.remove('hidden');
          $layer.show();
        }
      }
    },

    hideLayer() {
      const $layer = document.querySelector('#ents-layer__farben');
      if ($layer != null) {
        $layer.hide();
      }
    },

    compareImageArrays(oldImages, newImages) {
      return oldImages.every((v, i) => v.standardUrl === newImages[i].standardUrl);
    },

    jsonArtikelHasFarben(jsonArtikel) {
      return jsonArtikel !== undefined && jsonArtikel.farben;
    },

    jsonArtikelHasGroessen(jsonArtikel) {
      return jsonArtikel !== undefined && jsonArtikel.groessen && jsonArtikel.groessen.werte.length > 1;
    },

    getActiveArticleIdChainWithoutEntsDummyValues() {
      const jsonArtikel = this.$data.active;
      const produktId = this.$data.produktId;
      if (jsonArtikel) {
        const idChain = {
          syan: produktId,
          // artikelId: optional,
          // farbId: optional
        };
        if (jsonArtikel.farben) {
          idChain.farbId = jsonArtikel.farben.aktiv.farbId;
        }
        if (!jsonArtikel.initial) {
          idChain.artikelId = jsonArtikel.verkaufId;
          if (jsonArtikel.vertriebsinfoId) {
            idChain.vertriebsinfoId = jsonArtikel.vertriebsinfoId;
          }
        }

        return idChain;
      }
      return null;
    },

    triggerVariantenwechselEvents() {
      this.sendProductViewTracking();
      this.triggerExternesVariantenwechselEvent();
    },

    triggerExternesVariantenwechselEvent() {
      const payload = this.getActiveArticleIdChainWithoutEntsDummyValues();

      document.dispatchEvent(new CustomEvent('bewe:ents:variantenwechsel', {
        detail: payload,
      }));
      $(this.$el)
        .attr('data-test-bewerten-last-emitted-variantenwechsel-payload', JSON.stringify(payload));
    },

    sendPageviewTracking() {
      trackCubePageViewPds();
    },

    sendProductViewTracking() {
      const idChain = this.getActiveArticleIdChainWithoutEntsDummyValues();
      const lieferprognose = this.trackingStaticData.lieferprognose[idChain.artikelId];

      const productViewDetails = {
        currency: {
          code: this.trackingStaticData.waehrung,
        },
        items: [{
          syan: idChain.syan,
          farb_id: idChain.farbId,
          artikel_id: idChain.artikelId,
          vertriebsinfo_id: idChain.vertriebsinfoId,
          delivery_status_min_days: lieferprognose ? lieferprognose.standardVersandMinimumTage : null,
          delivery_status_max_days: lieferprognose ? lieferprognose.standardVersandMaximumTage : null,
          is_available: !this.active.outofstock,
        }],
      };

      trackProductView(productViewDetails);
    },
  },
});
